export {
    default as Check,
    ICheckProps,
} from './check';
